"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GridList = _interopRequireDefault(require("@material-ui/core/GridList"));

var _GridListTile = _interopRequireDefault(require("@material-ui/core/GridListTile"));

var _EmbedPreview = _interopRequireDefault(require("./components/EmbedPreview/EmbedPreview"));

var _ImgPreview = _interopRequireDefault(require("./components/ImgPreview/ImgPreview"));

var _JsonPreview = _interopRequireDefault(require("./components/JsonPreview/JsonPreview"));

var showPreview = function showPreview(file) {
  switch (file.type) {
    case 'application/pdf':
      return /*#__PURE__*/_react.default.createElement(_EmbedPreview.default, {
        file: file
      });

    case 'application/json':
      return /*#__PURE__*/_react.default.createElement(_JsonPreview.default, {
        file: file
      });

    default:
      return /*#__PURE__*/_react.default.createElement(_ImgPreview.default, {
        file: file
      });
  }
};

var Thumb = function Thumb(_ref) {
  var files = _ref.files;
  return /*#__PURE__*/_react.default.createElement(_GridList.default, {
    cellHeight: 100,
    cols: 3
  }, files.length && files.map(function (file) {
    return /*#__PURE__*/_react.default.createElement(_GridListTile.default, {
      key: file.preview,
      cols: 3
    }, file.name && showPreview(file));
  }));
};

var _default = Thumb;
exports.default = _default;
Thumb.propTypes = {
  files: _propTypes.default.arrayOf(_propTypes.default.shape({
    preview: _propTypes.default.string,
    name: _propTypes.default.string,
    type: _propTypes.default.string
  }))
};
Thumb.defaultProps = {
  files: []
};